import { useState, useEffect } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  Paper,
  Stack,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import axiosInstance from "../../../../services/apis/axiosInstance";
import styles from "./TermsConditionAdd.module.scss";

const TermsConditionAdd = () => {
  const [formData, setFormData] = useState({
    slug: "termsCondition",
    data: { en: "", hi: "" },
    comment: "",
    isActive: true,
  });

  const navigate = useNavigate();

  const handleChange =
    (field, lang = null) =>
    (event) => {
      if (lang) {
        setFormData((prev) => ({
          ...prev,
          data: {
            ...prev.data,
            [lang]: event.target.value,
          },
        }));
      } else {
        setFormData((prev) => ({
          ...prev,
          [field]:
            event.target.type === "checkbox"
              ? event.target.checked
              : event.target.value,
        }));
      }
    };

  const location = useLocation();
  const editPolicy = location?.state?.policy || null;

  useEffect(() => {
    if (editPolicy) {
      setFormData({
        slug: editPolicy?.slug || "",
        data: {
          en: editPolicy?.data?.en || "",
          hi: editPolicy?.data?.hi || "",
        },
        comment: editPolicy?.comment || "",
        isActive: editPolicy?.isActive ?? true,
      });
    }
  }, [editPolicy]);

  const handleSubmit = async () => {
    try {
      if (editPolicy) {
        await axiosInstance.post(`/singleton`, formData);
        alert("Terms & Condition updated successfully!");
      } else {
        await axiosInstance.post("/singleton", formData);
        alert("Terms & Condition added successfully!");
      }
      navigate("/pages/terms-condition");
    } catch (error) {
      console.error("Failed to add terms & condition:", error);
      alert("Failed to add terms & condition!");
    }
  };

  return (
    <Box className={styles.wrapper}>
      <Typography variant="h5" className={styles.heading}>
        Add New Terms & Condition
      </Typography>

      <Paper className={styles.formContainer} elevation={1}>
        <Stack spacing={3}>
          <Box>
            <Typography variant="subtitle1">Description </Typography>
            <TextField
              fullWidth
              multiline
              rows={4}
              value={formData?.data?.en}
              onChange={handleChange("data", "en")}
              variant="outlined"
            />
          </Box>

          <Box>
            <Typography variant="subtitle1">विवरण </Typography>
            <TextField
              fullWidth
              multiline
              rows={4}
              value={formData?.data?.hi}
              onChange={handleChange("data", "hi")}
              variant="outlined"
            />
          </Box>

          <Box>
            <Typography variant="subtitle1">Comment</Typography>
            <TextField
              fullWidth
              value={formData?.comment}
              onChange={handleChange("comment")}
              variant="outlined"
            />
          </Box>

          <Box>
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData?.isActive}
                  onChange={handleChange("isActive")}
                  color="primary"
                />
              }
              label="Is Active"
            />
          </Box>

          <Box>
            <Button variant="contained" color="primary" onClick={handleSubmit}>
              {editPolicy
                ? "Update Terms & Condition"
                : "Add Terms & Condition"}
            </Button>
          </Box>
        </Stack>
      </Paper>
    </Box>
  );
};

export default TermsConditionAdd;
